import { Header } from './Header.';
import Footer from './Footer';
import "./Styles/panier.css";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import storediv from "../Images/Icones/StoreDiv.svg";
import React, { useEffect } from "react";
import { Add } from '@mui/icons-material';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import PageHeader from './PageHeader';
import { getCart, getCartID, setCart } from '../Services/localStorage';
import Cookies from 'universal-cookie';
import TextField from '@mui/material/TextField';
import EmptyCardGIF from "../Images/empty-cart.gif"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import axios from "axios"
import { priceFr } from '../Services/Numbers';
import sha256 from 'crypto-js/sha256';
import moment from "moment/moment";

export const Panier = () => {
    const [deliveryAdress, setDeliveryAdress] = React.useState('');
    const [cart, setCartPanier] = React.useState([]);
    const [paymentMethod, setPaymentMethod] = React.useState(0);
    const [deliveryZonesList, setDeliveryZonesList] = React.useState([]);
    const [paymentMethodList, setPaymentMethodList] = React.useState([]);
    const [deliveryZone, setDeliveryZone] = React.useState(0);
    const [deliveryFee, setDeliveryFee] = React.useState(0);
    const [user, setUser] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const cookies = new Cookies();
    const isLoad = true;

    const transactionID = uuidv4();

    let total = 0;

    document.title = "Panier - KabaaShop"

    const productsURL = process.env.REACT_APP_API_BASE_URL + '/images/products/';
    const methodsURL = process.env.REACT_APP_API_BASE_URL + '/images/methods/';

    const goToLogin = () => {
        window.location.href = '/connexion?redirectTo=/panier'
    }

    const checkout = () => {
        if (cart.length == 0) {
            toast.error("Votre panier est vide !")
            return;
        }
        else if (deliveryZone == 0) {
            toast.error("Vous devez choisir une zone de livraison !")
            return;
        }
        else if (paymentMethod == 0) {
            toast.error("Vous devez choisir une méthode de paiement !")
            return;
        }

        setLoading(true)

        axios.post('https://core.copay.partners/auth/login',
            {
                email: 'info@kabaashop.com',
                password: 'fv3fbFKv0s7ix3wNAtb2'
            }, {
            headers: {
                'x-country': "SN"
            }
        }).then(a => {
            let data = a.data.payload

            const bearer = data.token.accessToken
            const paymentDate = new Date();

            const dateToken = paymentDate.getFullYear() + '-' + (paymentDate.getMonth() + 1) + '-' + paymentDate.getDate();
            const montant = parseInt(total+deliveryFee);
            
            const tokenToSend = sha256("COPAY_SN_PROD_NOuJt95UvCj1FUxDttmG" + montant + dateToken).toString();

            axios.post('https://core.copay.partners/api/v1/gichet-unique-api/create-payment',
                {
                    montantPaye: montant,
                    paiementDate: dateToken,
                    plateformeId: 'd1d62199-2122-47fa-b823-75a8ceb4b2f0',
                    idTransactionExt: transactionID,
                    commentaire: '',
                    typeTransaction: "Merchand",
                    partnerCallbackUrl: window.location.href+"?transaction="+transactionID,
                    redirectUrl: window.location.href+"?transaction="+transactionID
                }, {
                headers: {
                    'Content-Type': 'application/json',
                    "x-country" : "SN",
                    "x-api-key" : "5ed5bc80-b6e3-11ed-afa1-0242ac120002",
                    "Token" : tokenToSend,
                    'accept': '*/*',
                    "Authorization": "Bearer "+bearer
                }
            }).then(a => {
                setLoading(false)
                let link = a.data.payload.paymentLink
                cookies.set('transaction', {
                    transactionId: transactionID,
                    paymentMethod: 'api/payment_methods/'+paymentMethod,
                    deliveryZone: 'api/delivery_zones/'+deliveryZone,
                    status: 'confirmed',
                    total: montant,
                    deliveryPoint: deliveryAdress,
                    code: uuidv4(),
                    confirmedAt: new Date()
                }, { path: '/' })

                window.location.href = link               
            }).catch(error => {
                console.log(error);
                setLoading(false)
                toast.error("Une erreur est survenue !")
            })

        }).catch(error => {
            console.log(error);
            setLoading(false)
            toast.error("Une erreur est survenue !")
        })
    }

    useEffect(() => {
        setCartPanier(getCart())

        axios.get(process.env.REACT_APP_API_BASE_URL + '/api/delivery_zones', {
            headers: {
                'x-api-token': process.env.REACT_APP_API_TOKEN
            }
        }).then(a => {
            setDeliveryZonesList(a.data);

            if (cookies.get('user')) {
                setUser(cookies.get('user'));

                setDeliveryZone(cookies.get('user').defaultDeliveryZone ? cookies.get('user').defaultDeliveryZone : 0);
                setDeliveryAdress(cookies.get('user').address);
            }
        }).catch(error => {
            console.log(error);
        })

        axios.get(process.env.REACT_APP_API_BASE_URL + '/api/payment_methods', {
            headers: {
                'x-api-token': process.env.REACT_APP_API_TOKEN
            }
        }).then(a => {
            setPaymentMethodList(a.data);
        }).catch(error => {
            console.log(error);
        })

        const queryParameters = new URLSearchParams(window.location.search);

        const queryTransaction = queryParameters.get("transaction");

        if (queryTransaction !== null && cookies.get('transaction').transactionId == queryTransaction && cookies.get('user') !== undefined) {
            axios.patch(process.env.REACT_APP_API_BASE_URL + '/api/orders/' + getCartID(),
            cookies.get('transaction'),{
                headers: {
                    'x-api-token': cookies.get('user').setToken
                }
            }).then(a => {
                axios.post(process.env.REACT_APP_API_BASE_URL + '/services/email/sendToUser?type=LastOrderCheckout',{},
                {
                    headers: {
                        'x-api-token': cookies.get('user').setToken,
                    }
                }).then(a => {
                    toast.success('Votre commande a été validé avec succès ! Vous serez recontacter très bientôt pour la livraison');
                
                    cookies.remove("transaction")
                    setTimeout(() => {
                        window.location.href = "/commandes";
                    }, 2500);  
                }).catch(error => {
                    toast.success('Votre commande a été validé avec succès ! Vous serez recontacter très bientôt pour la livraison');
                
                    cookies.remove("transaction")
                    setTimeout(() => {
                        window.location.href = "/commandes";
                    }, 2500);
                })
            }).catch(error => {
                toast.error('Une erreur est survenue ! Essayez de recharger la page !')
                console.log(error);
            })
        }

    }, [isLoad])

    const deleteFromCart = (id) => {
        let tmpCart = cart

        tmpCart.splice(tmpCart.findIndex((obj) => obj.id === id), 1);

        setCartPanier(setCart(tmpCart))
    }

    const updateQuantity = (id, value) => {
        let index = cart.findIndex(x => x.id == id)

        if (value > 0) {
            cart[index].quantity += value
        }
        else {
            if (cart[index].quantity > 1) {
                cart[index].quantity += value
            }
        }

        setCartPanier(setCart(cart))
    }

    const changePaymentMethod = (id) => {
        setPaymentMethod(id)
    }

    return (
        <>
            <ToastContainer />
            <Header />
            <PageHeader title={'Panier'} />
            <div className='panier-box'>
                <div className='panier-box2'>
                    <div className='panier-box3'>
                        <p className='panier-title'>Panier</p>

                        {
                            cart.length > 0 ?
                                cart.map((p) => {
                                    total += parseInt(p.priceToPay * p.quantity);
                                    return (
                                        <>
                                            <img src={storediv} alt="storediv" className='div-product-separator' />
                                            <div className='GrosseDiv'>
                                                <div className='DivLeft'>
                                                    <img src={productsURL + p.image} alt={p.slug} />
                                                    <div className='DivInfo'>
                                                        <div className='DivInfoLabel'>
                                                            <span>{p.name}</span>
                                                            <span>{priceFr(p.priceToPay)} F</span>
                                                        </div>
                                                        <div className='PlusMoins'>
                                                            <IconButton onClick={() => { updateQuantity(p.id, -1) }}>
                                                                <RemoveIcon />
                                                            </IconButton>
                                                            <span>{p.quantity}</span>
                                                            <IconButton onClick={() => { updateQuantity(p.id, 1) }}>
                                                                <Add />
                                                            </IconButton>

                                                        </div>
                                                    </div>
                                                </div>
                                                <button onClick={() => { deleteFromCart(p.id) }} className="flexcenter connects3">
                                                    <DeleteForeverOutlinedIcon fontSize='small' />
                                                    <span>Supprimer</span>
                                                </button>
                                            </div>
                                        </>
                                    )
                                })
                                :
                                (
                                    <>
                                        <div className='no-products-in-cart'>
                                            <img src={EmptyCardGIF}  alt="empty"/>
                                        </div>
                                        <p style={{ textAlign: 'center', fontSize: '25px', fontWeight: 'bolder' }}>Panier Vide</p>
                                    </>
                                )
                        }

                    </div>
                    <div className='panier-box4'>
                        <Card className='cmd-resum-pannel' sx={{ maxWidth: 350, position: 'relative', marginTop: 2, marginLeft: 9.5, backgroundColor: '#F5F5FF' }}>

                            <CardContent className='row-resum-pannel' sx={{ padding: '5px' }}>

                                <div className="store-search">
                                    <p className='panier-card-p'>Résumé de commande</p>
                                </div>
                                <div className="store-div">
                                    <img src={storediv} alt="storediv" />
                                </div>
                                <p className='panier-store-card-p'><span>Articles:</span>  <span className='panier-store-card-span'>{priceFr(total)} F</span></p>
                                <p className='panier-store-card-p'><span>Frais de livraison:</span>   <span className='panier-store-card-span'>{priceFr(deliveryFee)} F</span></p>
                                <p className='panier-store-card-p3'><span>Total:</span>   <span className='panier-store-card-span'>{priceFr(total + deliveryFee)} F</span></p>

                            </CardContent>

                        </Card>
                        <Card sx={{ maxWidth: 350, position: 'relative', marginTop: 2, marginLeft: 9.5, backgroundColor: '#F5F5FF' }}>

                            <CardContent className='row-resum-payment' sx={{ padding: '5px' }}>

                                <div className="store-search">
                                    <p className='panier-card-p'>Informations Supplémentaires</p>
                                </div>
                                <div className='zone-livr-panier' style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}>
                                    <FormControl sx={{ width: "80%", marginBottom: '15px', border: '1px solid rgba(0,0,0,0.2)' }} size="small">
                                        <Select
                                            disabled={loading}
                                            value={deliveryZone}
                                            label="Zone de livraison"
                                            onChange={(e) => { setDeliveryZone(e.target.value); setDeliveryFee(deliveryZonesList.find(x => x.id == e.target.value).price) }}
                                            sx={{ '& legend': { display: 'none' }, '& fieldset': { display: 'none' } }}
                                        >
                                            <MenuItem value={0}>Zone de livraison</MenuItem>
                                            {
                                                deliveryZonesList.map(dz => {
                                                    return <MenuItem value={dz.id}>{dz.zone} ({priceFr(dz.price)}) F</MenuItem>
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        disabled={loading}
                                        sx={{ width: "80%" }}
                                        multiline
                                        maxRows={5}
                                        value={deliveryAdress}
                                        onChange={(e) => { setDeliveryAdress(e.target.value) }}
                                        placeholder='Lieu de livraison'
                                    />
                                </div>

                                <div className="store-search">
                                    <p className='panier-card-p'>Méthodes de paiement</p>
                                </div>
                                <div className='panier-payment-button'>
                                    {
                                        paymentMethodList.map(p => {
                                            return (
                                                <button onClick={() => { changePaymentMethod(p.id) }} className={paymentMethod == p.id ? 'paymentSelected' : ''}>
                                                    <img src={methodsURL + p.icon} alt={p.name} />
                                                </button>
                                            );
                                        })
                                    }
                                </div>

                                <div className='panier-button'>
                                    {
                                        user === null ?
                                            (
                                                <>
                                                    <p>Vous devez être connecter avant de pouvoir valider votre panier</p>
                                                    <button onClick={() => { goToLogin() }}>Se Connecter</button>
                                                </>
                                            ) :
                                            (
                                                <button disabled={loading} onClick={() => { checkout() }}>Commander</button>
                                            )
                                    }
                                </div>
                            </CardContent>

                        </Card>
                    </div>
                </div>
            </div>

            <Footer />

        </>
    )
}